export const urls={
    "apiUrl": "https://apiplatform.intellicar.in",
    "stagingApiUrl": "https://staging-apiplatform.intellicar.in"
}